import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface DeletePhotoActionSheetProps {
  isVisible: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeletePhotoActionSheet: React.FC<DeletePhotoActionSheetProps> = ({
  isVisible,
  onClose,
  onDelete,
}) => {
  const [styles] = useStyles();

  return (
    <BaseActionSheet
      isVisible={isVisible}
      onClose={onClose}
      showCloseButton={false}
    >
      <View style={styles.base}>
        <TouchableOpacity
          onPress={onDelete}
          style={[styles.border, styles.option]}
          testID="delete-preview-photo-confirm"
        >
          <Text style={[TYPOGRAPHY.pSemiBold, styles.deleteText]}>
            {i18n.t('camera.delete_photo')}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={onClose} style={styles.option}>
          <Text style={[TYPOGRAPHY.pSemiBold, styles.cancelText]}>
            {i18n.t('cancel')}
          </Text>
        </TouchableOpacity>
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    paddingHorizontal: 8,
  },
  border: {
    borderBottomColor: theme.colors.background,
    borderBottomWidth: 1,
  },
  cancelText: {
    color: theme.colors.black,
    fontSize: 18,
  },
  deleteText: {
    color: theme.colors.negative,
    fontSize: 18,
  },
  option: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 16,
    paddingVertical: 16,
  },
}));
